import React from "react";

const Pokeball = ({ className = "", style }) => (
  <svg viewBox="0 0 100 100" className={className} style={style} aria-hidden>
    <defs>
      <radialGradient id="pb-top" cx="35%" cy="35%" r="70%">
        <stop offset="0%" stopColor="#fca5a5" />
        <stop offset="60%" stopColor="#dc2626" />
        <stop offset="100%" stopColor="#7f1d1d" />
      </radialGradient>
      <radialGradient id="pb-bot" cx="35%" cy="35%" r="80%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="80%" stopColor="#e5e7eb" />
        <stop offset="100%" stopColor="#9ca3af" />
      </radialGradient>
      <radialGradient id="pb-btn" cx="35%" cy="35%" r="70%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="100%" stopColor="#d1d5db" />
      </radialGradient>
    </defs>
    <circle cx="50" cy="50" r="48" fill="url(#pb-bot)" stroke="#0f172a" strokeWidth="3" />
    <path d="M2 50 A48 48 0 0 1 98 50 Z" fill="url(#pb-top)" stroke="#0f172a" strokeWidth="3" />
    <rect x="2" y="46" width="96" height="8" fill="#0f172a" />
    <circle cx="50" cy="50" r="11" fill="#0f172a" />
    <circle cx="50" cy="50" r="7" fill="url(#pb-btn)" stroke="#0f172a" strokeWidth="1.5" />
    <circle cx="48" cy="48" r="2" fill="#ffffff" opacity="0.9" />
    <ellipse cx="35" cy="22" rx="12" ry="5" fill="#ffffff" opacity="0.35" />
  </svg>
);

export default Pokeball;
